import { SyntheticEvent, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { settingsOptions } from '../../../app/common/options/otherOptions/approveOptions';
import { useStore } from '../../../app/stores/store';
import {
  WorkflowOptions,
  WorkflowElement,
} from './../../../app/models/template';
import CommonComponentSettings from '../commonSettings';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import './index.css';

interface Props {
  elements: WorkflowElement;
  elementsNames: {
    key: string;
    value: string;
    text: string;
  }[];
}

function WorkflowSettings({ elementsNames }: Props) {
  const {
    TemplateStore,
    modalStore,
    workflowConfigurationStore,
    ElementStore,
  } = useStore();

  const { loadAllworkflowmetadata, loadAllWorkflowTaskAndSubTask } =
    ElementStore;

  const {
    selectedElement,
    editSettingsElements,
    selectedSubTasks,
    loadSubTaskById,
    // loadElementById,
    selectedAssetType,
    selectedElementTypes,
  } = TemplateStore;

  const [selected, setSelected] = useState<string>('');
  const [scanType, setScanType] = useState<string>('');
  // elements array which was enable by default as false;
  const [elementArr, setElementArr] = useState<WorkflowElement[] | undefined>(
    undefined,
  );

  useEffect(() => {
    if (selectedElement?.elementType?.includes('ScanArea')) {
      setSelected(selectedElement?.elementType.split('|')[0]);
      setScanType(selectedElement?.elementType.split('|')[1] || 'Neutral');
    } else if (selectedElement?.elementType?.includes('CurrentUser')) {
      setSelected(selectedElement?.elementType?.split('|')[0]);
    } else {
      setSelected(selectedElement?.elementType || '');
    }
    // if (selectedSubTasks !== undefined) {
    //   loadSubTaskById(selectedSubTasks.subTaskId);
    // }
    // eslint-disable-next-line
  }, [selectedElement?.elementType]);

  // useEffect(() => {
  //   if (selectedSubTasks?.subTaskId) {
  //     loadElementById(selectedSubTasks.subTaskId);
  //   }
  //   // eslint-disable-next-line
  // }, [selectedSubTasks?.subTaskId]);

  useEffect(() => {
    loadAllworkflowmetadata(selectedSubTasks?.subTaskId);
    loadAllWorkflowTaskAndSubTask(selectedElementTypes?.id);
    // eslint-disable-next-line
  }, [selectedAssetType]);

  useEffect(() => {
    if (selectedSubTasks) {
      setElementArr(
        selectedSubTasks.elements.filter(
          (x) => x.elementId !== selectedElement?.elementId,
        ),
      );
    }
    // eslint-disable-next-line
  }, [selectedSubTasks]);

  const changeSelectOptionHandler = (e: SyntheticEvent, data: any) => {
    setSelected(data.value);
  };

  const handleSave = (data: {
    value: any;
    isReadOnly: boolean;
    isMandatory: boolean;
    enableByDefault: boolean;
    parentId: string;
    optionsState: WorkflowOptions[];
    isMultiple?: boolean;
    validation?: string;
    parentDynamicDetails?: {
      parentDynamicId: string;
      templateId: string;
      elementTypeId: string;
      assetTypeId: string;
    };
    scanAreaType?: string;
    selectMasterComponent: string;
    autoPopulate: string;
  }) => {
    let {
      value,
      isReadOnly,
      isMandatory,
      isMultiple,
      enableByDefault,
      parentId,
      parentDynamicDetails,
      validation,
      optionsState,
      scanAreaType = 'Neutral',
      selectMasterComponent,
      autoPopulate,
    } = data || {};

    let copySelectedElement = Object.assign({}, selectedElement);
    if (copySelectedElement !== undefined) {
      let tempElementType = '';
      switch (selected) {
        case 'ScanArea':
          tempElementType = selected
            .concat('|')
            .concat(scanAreaType || 'Neutral');
          break;
        case 'CurrentUser':
          tempElementType = selected.concat('|').concat(autoPopulate);
          break;
        default:
          tempElementType = selected;
          break;
      }

      copySelectedElement = {
        ...copySelectedElement,
        elementType: tempElementType,
        readOnly: isReadOnly,
        isMandatory,
        enableByDefault,
        parentId,
        options: [],
        elementValue: value,
        isMultiple: !!isMultiple,
        selectMasterComponent: selectMasterComponent,
      };
      // const elemArr = [...(selectedSubTasks?.elements || [])];

      if (selected === 'ParentDynamicmetadata') {
        copySelectedElement = {
          ...copySelectedElement,
          parentDynamicDetails,
        };
      } else if (
        selected === 'DropDown' ||
        selected === 'DynamicTable' ||
        selected === 'dropdownWithTab' ||
        selected === 'tab'
      ) {
        copySelectedElement = {
          ...copySelectedElement,
          isMultiple: !!isMultiple,
          validation: '',
          options: optionsState,
        };
      } else {
        ///for Barcode
        const BC1 =
          workflowConfigurationStore.WorkflowConfiguration.barcodeValue1 === ''
            ? ''
            : '-' +
              workflowConfigurationStore.WorkflowConfiguration.barcodeValue1;
        const BC2 =
          workflowConfigurationStore.WorkflowConfiguration.barcodeValue2 === ''
            ? ''
            : '-' +
              workflowConfigurationStore.WorkflowConfiguration.barcodeValue2;
        const url =
          workflowConfigurationStore.WorkflowConfiguration.barcodeValue0
            ?.concat(BC1)
            ?.concat(BC2);

        const newArrBC = {
          ...selectedElement,
          elementType: selected,
          validation: validation || '',
          elementValue: `${url}|${workflowConfigurationStore.WorkflowConfiguration.barcodeType}`,
          options: [],
        };
        if (selected === 'Barcode') {
          // const updatedObj = elemArr?.map((selectedElem) =>
          //   selectedElem.elementId === selectedElement.elementId
          //     ? newArrBC
          //     : selectedElem
          // );
          // const subTaskArr: any = {
          //   // for front end schema
          //   ...selectedSubTasks,
          //   elements: updatedObj,
          // };
          editSettingsElements(newArrBC);
        } else if (
          selected === 'TextBox' ||
          selected === 'TextArea' ||
          selected === 'ScanArea'
        ) {
          copySelectedElement = {
            ...copySelectedElement,
            validation: validation || '',
          };
        }
        // parent
        else if (selected === 'Parent') {
          copySelectedElement = {
            ...copySelectedElement,
            enableByDefault: true,
          };
        }
        sendRespectiveEmail(
          'edited',
          copySelectedElement.elementName,
          'Edited Element',
          '',
        ); //email Function
      }
      editSettingsElements(copySelectedElement);
    }
    modalStore.closeModal();
    setSelected('');
    //  setEnableBydefaultState(false);
    loadSubTaskById(selectedSubTasks?.subTaskId);
    //  setOpenLink('')
  };
  const handleClose = () => {
    setSelected('');
    // setEnableBydefaultState(false);
    // setOpenLink('')
    modalStore.closeModal();
  };

  const classFunc = () => {
    if (selected === 'Barcode') {
      if (
        workflowConfigurationStore.WorkflowConfiguration.barcodeType === '' ||
        workflowConfigurationStore.WorkflowConfiguration.barcodeType ===
          undefined ||
        workflowConfigurationStore.WorkflowConfiguration.barcodeType === null ||
        workflowConfigurationStore.WorkflowConfiguration.barcodeValue0 === '' ||
        workflowConfigurationStore.WorkflowConfiguration.barcodeValue0 ===
          undefined ||
        workflowConfigurationStore.WorkflowConfiguration.barcodeValue0 === null
      ) {
        return { pointerEvents: 'none', opacity: 0.5 };
      }
    }
    return { pointerEvents: 'auto', opacity: 1 };
  };

  return (
    <>
      {selectedElement && (
        <CommonComponentSettings
          className={'workflowSettingsForm'}
          selectedElement={selectedElement}
          elementOptionDetails={elementsNames}
          elementsArray={elementArr || []}
          settingsOptions={settingsOptions}
          selectedSetting={selected}
          submitClassFunc={classFunc}
          changeSelectOptionHandler={changeSelectOptionHandler}
          handleClose={handleClose}
          handleSave={handleSave}
          scanType={scanType}
        />
      )}
    </>
  );
}

export default observer(WorkflowSettings);
